import { render } from "./avatar-configurator.vue?vue&type=template&id=530f30dd"
import script from "./avatar-configurator.vue?vue&type=script&lang=js"
export * from "./avatar-configurator.vue?vue&type=script&lang=js"

import "./avatar-configurator.vue?vue&type=style&index=0&id=530f30dd&lang=scss"

import exportComponent from "F:\\DEV\\estimationpoker\\webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__